import { render } from "./options-sidebar.vue?vue&type=template&id=23c1a487&scoped=true"
import script from "./options-sidebar.vue?vue&type=script&lang=js"
export * from "./options-sidebar.vue?vue&type=script&lang=js"

import "./options-sidebar.vue?vue&type=style&index=0&id=23c1a487&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c1a487"]])

export default __exports__